class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.facetForm = null
    this.collectionSection = null
    this.loading = false
  }

  connectedCallback() {
    this.facetForm = this.querySelector('form') || this
    this.collectionSection = document.getElementById('collection')

    const clearBtn = document.querySelector('.filters-clear-btn')
    if (clearBtn) {
      clearBtn.addEventListener('click', this.handleClear.bind(this))
    }

    const applyBtn = document.querySelector('.filters-apply-btn')
    if (applyBtn) {
      applyBtn.addEventListener('click', this.handleSubmit.bind(this))
    }

    const sortApplyBtn = document.querySelector('.sort-apply-btn')
    if (sortApplyBtn) {
      sortApplyBtn.addEventListener('click', this.handleSortApply.bind(this))
    }

    const sortClearBtn = document.querySelector('.sort-clear-btn')
    if (sortClearBtn) {
      sortClearBtn.addEventListener('click', this.handleSortClear.bind(this))
    }

    this.setupFacetRemove()
  }

  setupFacetRemove() {
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.js-facet-remove')
      if (!removeBtn) return

      e.preventDefault()

      const href = removeBtn.getAttribute('href')
      if (!href) return

      const removeUrl = new URL(href, window.location.origin)
      const removeParams = new URLSearchParams(removeUrl.search)
      const currentUrl = new URL(window.location.href)
      const currentParams = new URLSearchParams(currentUrl.search)

      const removedParams = []
      currentParams.forEach((value, key) => {
        if (key === 'q') {
          const removeQValues = removeParams.getAll('q')
          if (!removeQValues.includes(value)) {
            removedParams.push({ key, value })
          }
        } else if (!removeParams.has(key) || !removeParams.getAll(key).includes(value)) {
          removedParams.push({ key, value })
        }
      })

      removedParams.forEach(({ key, value }) => {
        if (key === 'sort_by' || key === 'sort-by') {
          const sortInput = this.facetForm.querySelector(`input[name="sort-by"][value="${value}"]`)
          if (sortInput) {
            sortInput.checked = false
          }
        } else {
          const checkbox = this.facetForm.querySelector(`input[type="checkbox"][name="${key}"][value="${value}"]`)
          if (checkbox) {
            checkbox.checked = false
          }
        }
      })

      this.updateURL(removeParams.toString())
      this.updateProductGrid(removeParams.toString())
    })
  }

  setupSearchType() {
    document.addEventListener('click', (e) => {
      const searchTypeBtn = e.target.closest('.js-search-type')
      if (!searchTypeBtn || searchTypeBtn.classList.contains('active')) return

      e.preventDefault()

      const href = searchTypeBtn.getAttribute('href')
      if (!href) return

      const searchTypeUrl = new URL(href, window.location.origin)
      const searchTypeParams = new URLSearchParams(searchTypeUrl.search)

      // Preserve all existing q parameters
      const currentUrl = new URL(window.location.href)
      const currentQValues = currentUrl.searchParams.getAll('q')

      // If the new URL has q parameters, use those; otherwise preserve current ones
      const newQValues = searchTypeParams.getAll('q')
      const qValuesToUse = newQValues.length > 0 ? newQValues : currentQValues

      // Build new params with preserved q values and the type parameter
      const params = new URLSearchParams()
      qValuesToUse.forEach(query => {
        params.append('q', query)
      })

      // Add the type parameter from the clicked link
      const typeValue = searchTypeParams.get('type')
      if (typeValue) {
        params.set('type', typeValue)
      }

      // Preserve other existing parameters (filters, sort, etc.)
      currentUrl.searchParams.forEach((value, key) => {
        if (key !== 'q' && key !== 'type') {
          params.append(key, value)
        }
      })

      this.updateURL(params.toString())
      this.updateProductGrid(params.toString())
    })
  }

  createSearchParams(form) {
    const params = new URLSearchParams()

    const checkedCheckboxes = form.querySelectorAll('input[type="checkbox"]:checked')
    checkedCheckboxes.forEach(checkbox => {
      params.append(checkbox.name, checkbox.value)
    })

    const sortInput = form.querySelector('input[type="radio"][name="sort-by"]:checked')
    if (sortInput) {
      params.set('sort_by', sortInput.value)
    }

    const url = new URL(window.location.href)
    const searchQueries = url.searchParams.getAll('q')
    searchQueries.forEach(query => {
      params.append('q', query)
    })

    // Preserve type parameter
    const typeValue = url.searchParams.get('type')
    if (typeValue) {
      params.set('type', typeValue)
    }

    return params.toString()
  }

  updateURL(params) {
    const url = new URL(window.location.href)
    url.search = params
    history.pushState({}, '', url)
  }

  async updateProductGrid(params) {
    if (!this.collectionSection) return

    this.loading = true
    this.collectionSection.classList.add('loading')

    try {
      const url = new URL(window.location.href)
      url.search = params

      const response = await fetch(url)
      if (!response.ok) throw new Error('Failed to fetch')

      const html = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      const newCollectionSection = doc.getElementById('collection')
      if (newCollectionSection) {
        this.collectionSection.innerHTML = newCollectionSection.innerHTML

        this.collectionSection.querySelectorAll('script').forEach((oldScript) => {
          const newScript = document.createElement('script')
          Array.from(oldScript.attributes).forEach((attr) => {
            newScript.setAttribute(attr.name, attr.value)
          })
          newScript.textContent = oldScript.textContent
          oldScript.parentNode.replaceChild(newScript, oldScript)
        })
      }

      const searchTop = document.querySelector('.collection-top')
      const newSearchTop = doc.querySelector('.collection-top')
      if (searchTop && newSearchTop) {
        const currentRenderElements = searchTop.querySelectorAll('[data-render]')
        const newRenderElements = newSearchTop.querySelectorAll('[data-render]')

        currentRenderElements.forEach((currentEl, index) => {
          if (newRenderElements[index]) {
            currentEl.innerHTML = newRenderElements[index].innerHTML
          }
        })

        const currentSearchTypeBtns = searchTop.querySelectorAll('.js-search-type')
        const newSearchTypeBtns = newSearchTop.querySelectorAll('.js-search-type')

        currentSearchTypeBtns.forEach((currentBtn, index) => {
          if (newSearchTypeBtns[index]) {
            const newBtn = newSearchTypeBtns[index]
            if (newBtn.classList.contains('active')) {
              currentBtn.classList.add('active')
            } else {
              currentBtn.classList.remove('active')
            }
            // Update href to match new URL params
            currentBtn.setAttribute('href', newBtn.getAttribute('href'))
          }
        })

    const currentSearchTopGrid = searchTop.querySelector('.js-products-top-grid') || searchTop.querySelector('.js-search-top-grid')
    const newSearchTopGrid = newSearchTop.querySelector('.js-products-top-grid') || newSearchTop.querySelector('.js-search-top-grid')
        if (currentSearchTopGrid && newSearchTopGrid) {
          if (newSearchTopGrid.classList.contains('hidden')) {
            currentSearchTopGrid.classList.add('hidden')
            currentSearchTopGrid.classList.remove('flex')
          } else {
            currentSearchTopGrid.classList.remove('hidden')
            currentSearchTopGrid.classList.add('flex')
          }
        }
      }

    } catch (error) {
      console.error('Failed to update product grid:', error)
    } finally {
      this.loading = false
      this.collectionSection.classList.remove('loading')
      this.closeMenus()
    }
  }

  closeMenus() {
    const filterMenu = document.querySelector('.filter-menu')
    if (filterMenu) {
      filterMenu.style.display = 'none'
    }

    const sortMenu = document.querySelector('.sort-menu')
    if (sortMenu) {
      sortMenu.style.display = 'none'
    }

    document.querySelectorAll('.menu-overlay').forEach(overlay => {
      overlay.style.display = 'none'
    })
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault()
    }

    const params = this.createSearchParams(this.facetForm)
    this.updateURL(params)
    this.updateProductGrid(params)
  }

  handleClear(event) {
    if (event) {
      event.preventDefault()
    }

    this.facetForm.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false
    })

    const url = new URL(window.location.href)
    const searchQueries = url.searchParams.getAll('q')
    const params = new URLSearchParams()

    searchQueries.forEach(query => {
      params.append('q', query)
    })

    // Preserve type parameter
    const typeValue = url.searchParams.get('type')
    if (typeValue) {
      params.set('type', typeValue)
    }

    this.updateURL(params.toString())
    this.updateProductGrid(params.toString())
  }

  handleSortApply(event) {
    if (event) {
      event.preventDefault()
    }

    const sortInput = this.facetForm.querySelector('input[name="sort-by"]:checked')
    if (!sortInput) return

    const params = this.createSearchParams(this.facetForm)
    this.updateURL(params)
    this.updateProductGrid(params)
  }

  handleSortClear(event) {
    if (event) {
      event.preventDefault()
    }

    this.facetForm.querySelectorAll('input[name="sort-by"]').forEach(input => {
      input.checked = false
    })

    const url = new URL(window.location.href)
    const searchQueries = url.searchParams.getAll('q')
    const params = new URLSearchParams()

    searchQueries.forEach(query => {
      params.append('q', query)
    })

    // Preserve type parameter
    const typeValue = url.searchParams.get('type')
    if (typeValue) {
      params.set('type', typeValue)
    }

    url.searchParams.forEach((value, key) => {
      if (key !== 'sort_by' && key !== 'sort-by' && key !== 'q' && key !== 'type') {
        params.append(key, value)
      }
    })

    this.updateURL(params.toString())
    this.updateProductGrid(params.toString())
  }
}

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm)
}
